import React, { PropTypes } from "react";
import Toggle from "react-toggle";
import { FormattedMessage } from "react-intl";
import { getUrlParam } from "../../../../utils/url";
import { FR, EN } from "../enums/languages";

class LanguageToggle extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleToggleChange = this.handleToggleChange.bind(this);
    this.setLocalStorage = this.setLocalStorage.bind(this);
    this.checkForLocalStorage = this.checkForLocalStorage.bind(this);
    this.state = {
      chosenLanguage: null,
    };
  }

  componentDidMount() {
    let currentUserLang = getUrlParam("languageCode");
    if(currentUserLang == undefined) {
        let hasLocalStorage = this.checkForLocalStorage();
        currentUserLang = hasLocalStorage;

        if (
          !hasLocalStorage ||
          (hasLocalStorage !== EN.value && hasLocalStorage !== FR.value)
        ) {
          currentUserLang = localStorage.getItem("languageCode") || EN.value;
        }
  }
      
    this.setState({ chosenLanguage: currentUserLang });
    this.props.setLanguageCode(currentUserLang); // This prop function will set the languagecode for the field component (which will fetch the data every time user switches language)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.chosenLanguage !== this.state.chosenLanguage) {
      this.setLocalStorage(this.state.chosenLanguage);
      this.props.setLanguageCode(this.state.chosenLanguage); // This prop function will set the languagecode for the field component (which will fetch the data every time user switches language)
    }
  }

  checkForLocalStorage() {
    /**
     * Function that will check if user already has a local storage variable for the downloadLanguage.
     */
    return localStorage.getItem("downloadLanguage");
  }

  setLocalStorage(lang) {
    localStorage.setItem("downloadLanguage", lang);
  }

  handleToggleChange(e) {
    const isCheckedEn = e.target.checked;

    if (isCheckedEn) {
      this.setState({ chosenLanguage: "en-CA" });
    } else {
      this.setState({ chosenLanguage: "fr-CA" });
    }
  }

  render() {
    const flexClasses = this.props.flexClasses || "";
    
    return (
      <div className={`flex ${flexClasses}`}>
        {this.state.chosenLanguage == "fr-CA" && (
          <label className="language-label">
            <FormattedMessage id="versionToggle.fr" />
          </label>
        )}

        {this.state.chosenLanguage == "en-CA" && (
          <label className="language-label">
            <FormattedMessage id="versionToggle.en" />
          </label>
        )}

        <label className="toggle-color">
          {this.state.chosenLanguage && (
            <Toggle
              defaultChecked={this.state.chosenLanguage == "en-CA"}
              icons={{
                checked: null,
                unchecked: null,
              }}
              onChange={this.handleToggleChange}
            />
          )}
        </label>
      </div>
    
    );
  }
}

LanguageToggle.propTypes = {
  setLanguageCode: PropTypes.func,
  flexClasses: PropTypes.string
};

export default LanguageToggle;



// WEBPACK FOOTER //
// ./src/components/common/LanguageToggle/LanguageToggle.js